<!-- eslint-disable no-debugger -->
<template>
  <div class="fatherHeight">
    <div class="hande weSet">
      <!-- 头部第一行 -->
      <div class="flex-between">
        <div class="flex-start">
          <!-- 左侧 -->
          <el-form :inline="true" :model="formInline" class="demo-form-inline search">
            <el-form-item label="院区:" label-width="50px">
              <el-select v-model="formInline.Yval" placeholder="请选择">
                <el-option v-for="item in Ylist" :key="item.id" :label="item.name" :value="item.name"
                  @click="hospi(item.id)">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间:" label-width="50px">
              <el-date-picker v-model="formInline.time" type="date" value-format="YYYY-MM-DD"
                placeholder="请选择时间"></el-date-picker>
            </el-form-item>
            <el-form-item label="班次:" label-width="50px">
              <el-select v-model="formInline.user" placeholder="请选择" @change="banciChange">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 姓名 -->
            <el-form-item label="姓名:">
              <el-input v-model="formInline.name" placeholder="搜索姓名/首拼">
                <template #suffix>
                  <el-icon class="el-input__icon">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="color-main" @click="refresh" type="primary">
                <i class="fa fa-refresh"></i>重置
              </el-button>
              <el-button @click="search" class="color-main" type="primary">
                <i class="fa fa-search"></i>查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 中间内容部分 -->
    <div class="bodycliss">
      <!-- 左侧 -->
      <div class="lifebody">
        <el-scrollbar>
          <div v-if="list.length === 0">
            <el-empty description="暂无数据！"></el-empty>
          </div>
          <div class="card-box">
            <div class="zy-bord" :class="[listIndex === index ? '' : '']" v-for="(item, index) in list" :key="index"
              @click="bodycl(index, item)">
              <div class="userinfo-item">
                <div
                  :class="item.is_sign === 1 ? 'userinfo-item-top flex-between signed' : 'userinfo-item-top flex-between'">
                  <div class="nameBox">
                    <div class="name">{{ item.patient_name }}</div>
                  </div>
                  <el-tag v-if="item.is_sign === 1" type="primary">{{ item.status_str }}</el-tag>
                  <!-- <el-button v-if="item.is_sign === 0" type="primary" size="small" circle
                    @click.stop="Pclick(item, index)">签</el-button> -->
                </div>
                <div class="userinfo-item-bottom">
                  <div class="flex-between">
                    <div class="_item">年龄: {{ item.patient.age }}岁</div>
                    <div class="_item">
                      性别:{{ item.patient.dict_sex_name }}性
                    </div>
                  </div>
                  <div class="flex-between">
                    <div class="_item" v-if="item.bedReg != null">结算类别:{{ item.bedReg.dict_pay_cate == '4040' ? '医保' :
                      '自费' }}
                    </div>
                  </div>
                  <div class="flex-between">
                    <div class="_item">床位号:{{ item.bed_num }}</div>
                    <div class="_item">透析方式:{{ item.record ? item.record.dict_dialysis_type_name : '' }}</div>
                  </div>
                  <div class="_item" v-if="item.record">
                    抗凝剂:{{ item.record.dict_kangning_name }}
                    {{ item.record.kangning_shouji_num }}
                    {{ item.record.dict_kangning_shouji_unit_name }}
                  </div>
                  <div class="_item" v-if="item.record">
                    目标脱水:{{ item.record.target_warter || '--' }}ml
                  </div>
                  <div class="_item" v-if="item.record">
                    血管通路:{{ item.record.dict_tonglu_name }}
                  </div>
                  <div class="_item" v-if="item.dialysis_time">
                    透析时长:{{ item.dialysis_time }}
                  </div>
                  <div class="_item">
                    <span style="color: #f00" v-if="item.countdown != 0">
                      倒计时:{{ item.countdownZw }}
                    </span>
                    <span class="info-btn" v-if="item.show_off">
                      <img class="logoImg" src="@/assets/img/ions/tanhao.png" />
                      待下机
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Search,
    CirclePlus,
    Tools,
    Histogram,
    Close,
    Plus,
  } from '@element-plus/icons-vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { gitDictList, TimeYear } from '@/utils/tool'
  import { ElMessageBox, ElMessage } from 'element-plus'
  // import { isTemplate } from 'element-plus/lib/utils'
  import print from 'vue3-print-nb'
  import { useStore } from 'vuex'
  import { watch } from "vue";
  import { useRoute, onBeforeRouteUpdate } from 'vue-router'
  const route = useRoute()
  export default {
    name: 'TXjilu',
    components: {
      Search,
      CirclePlus,
      Tools,
      Plus,
      Histogram,
      Close,
      BaseDialog,
    },
    directives: {
      print,
    },
    data() {
      return {
        listIndex: 0,
        sutas: true,
        preconval: {},
        value1: '',
        input3: '',
        lisding: false,
        Kningvais: false,
        tmbleval: false,
        puncture: false,
        bodyvlus: false,
        bedval: false,
        addtmb: true,
        tmpl_content: '',
        formInline: {
          user: '',
          time: TimeYear(new Date()),
          beforeOpenCallback: () => {
            return false
          },
        },

        list: [],
        tmplist: [],

        options: [],
        BtnIndex: 0,
        value: '',
        Ylist: [],
        hospid: '',
        tmb_id: null,
        ruleForm: {},
        tmb_Index: 0,
        record_id: null,
        imgval:
          'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',

        actPatientData: {},
        signin: false,
        radiopiercing: '1',

        disabled: true,
        reception: [],
        receptionIndex: 0,
        bed_no: [],
        bidIndex: null,
        sid: null,
        defaultBanci: '',
        zhenDuan: [],
        timer: null,
      }
    },
    async created() {
      this.getMOnTOSun()
      this.getZhenDuan()
      if (JSON.stringify(this.$route.query) === "{}") {
        const store = useStore()
        console.log(store.state)
        let z = store.state.addHZ
        console.log(z)
        this.getDefaultBanci()
        // 获取院区列表
        setTimeout(() => {
          this.Yanqu()
        }, 1000);
      } else {
        for (const key in this.$route.query) {
          this.formInline[key] = this.$route.query[key]
        }
        console.log(this.formInline)
        setTimeout(() => {
          this.Yanqu()
        }, 1000);
      }

      this.timer = setInterval(this.timeOUt, 1000)

      // 获取缓存数据
      // const user = localStorage.getItem('ms_userData')
      // this.userInfo.push(JSON.parse(user))
    },
    unmounted() {
      clearInterval(this.timer)
    },
    methods: {
      async getZhenDuan() {
        let res = await service.post('/api/config/get_diag_config')
        if (res.code === 0) {
          this.zhenDuanList = res.data.diag_conf
          res.data.diag_conf.forEach(item => {
            this.zhenDuan.push(item.name)
          })
        }
      },

      async getMOnTOSun() {
        let res = await service.post('/api/week/mon_to_sun', {
          week: 179,
        })
        if (res.code === 0) {
          let arr = []
          res.data.info.push('全天')
          res.data.info.forEach(item => {
            let obj = {}
            if (item == '全天') {
              obj = {
                label: item,
                value: ''
              }
            }
            else {
              obj = {
                label: item,
                value: item
              }
            }
            arr.push(obj)
          })
          this.options = arr
          console.log(222, this.options)
        }
      },
      async getDefaultBanci() {
        let res = await service.post('/api/common/get_default_banci')
        if (res.code === 0) {
          this.defaultBanci = res.data.nm_name
          this.formInline.user = this.defaultBanci
        }
      },


      // 左侧列表点击事件
      async bodycl(index, item) {
        let group = JSON.stringify(item.group)
        console.log(this.formInline.user)
        this.$router.push({
          path: '/TXjilu/info',
          query: { ...item, date: this.formInline.time, user: this.formInline.user, group: encodeURIComponent(group) }
        })
      },

      // 院区列表
      async Yanqu() {
        const val = await service.post('/api/hospital/list', { parent_id: 0 })
        if (val.code === 0) {
          this.hospi(val.data[0].id)
          this.Ylist = val.data
          this.formInline.Yval = val.data[0].name
          this.hospid = val.data[0].id
        }
        this.user()
      },
      banciChange(e) {
        console.log(e)
        this.formInline.user = e
        this.defaultBanci = e
        this.search()
      },
      // 获取用户列表
      async user() {
        let data = {
          nm_name: this.formInline.user,
          hospital_area_id: this.hospid,
          is_sign: -1,
          date: this.formInline.time,
          patient_name: this.formInline.name,
        }
        const val = await service.post('/api/dialysis_record/patient', data)
        this.listIndex = 0
        if (val.code === 0) {
          this.list = val.data
          if (this.list.length > 0) {
            if (this.listIndex < this.list.length - 1) {
              this.actPatientData = val.data[this.listIndex]
            } else {
              this.actPatientData = val.data[0]
            }
            this.record_id = this.actPatientData.record_id
            this.group = [this.actPatientData.group]
          } else {
            this.actPatientData = {}
          }
          clearInterval(this.timer)
          this.list.forEach((item) => {
            let h = Math.floor(item.countdown / 3600)
            let m = Math.floor((item.countdown / 60) % 60)
            let s = item.countdown % 60
            let hour = h < 10 ? '0' + h : h
            let min = m < 10 ? '0' + m : m
            let sec = s < 10 ? '0' + s : s
            item.countdownZw = `${hour}:${min}:${sec}`

          })
          this.timer = setInterval(this.timeOUt, 1000)
        }

      },

      // 院区选择
      async hospi(id) {
        const res = await service.post('/api/hospital/list', { parent_id: id })
        if (res.code === 0) {
          console.log(res)
          this.reception = res.data
          this.sid = res.data[0].hospital.id
        }
        this.hospid = id

        this.user()
      },
      // 查询
      search() {
        this.user()
      },
      // 重置
      refresh() {
        this.$message({
          message: '重置成功',
          type: 'success',
        })
        this.formInline.user = this.defaultBanci
        this.formInline.time = TimeYear(new Date())
        this.formInline.Yval = this.Ylist[0].name
        this.hospid = this.Ylist[0].id
        this.user()
      },
    },
  }
</script>
<style scoped lang="scss">
  @media only screen and (max-width: 1980px) {
    .card-box {
      display: grid;
      grid-template-columns: repeat(8, 12.5%);
    }
  }

  @media only screen and (max-width: 1600px) {
    .card-box {
      display: grid;
      grid-template-columns: repeat(5, 20%);
    }
  }

  @media only screen and (max-width: 1200px) {
    .card-box {
      display: grid;
      grid-template-columns: repeat(4, 25%);
    }
  }

  @import "index.scss";
  /*/deep/ .el-form-item {*/
  /*  margin-bottom: 8px;*/
  /*}*/

  /*/deep/ .el-form-item__error {*/
  /*  display: none;*/
  /*}*/
  .Steps {
    //height: 64px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 1;
    margin-bottom: 2px;
    padding: 8px 2%;

    &:deep(.el-steps) {
      .el-step__title {
        font-size: 14px;
        line-height: 32px;
      }
    }
  }

  .ell {
    &.mar {
      margin-right: 8px;
    }

    &:deep(.el-tag__content) {
      max-width: 48px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .clinicalreception {
    height: 20px;
    line-height: 18px;
    border-radius: 32px;
    border: 1px solid #f4a939;
    font-size: 10px;
    color: #f4a939;
    padding: 0 4px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .zy-bord .userinfo-item-top .pcls[data-v-31bfd229] {
    height: 22px;
    line-height: 22px;
    background: #d4deeb;
    border-radius: 4px;
    font-size: 12px;
    padding: 0 4px;
    color: #3167a8;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .userinfo-item-top.signed {
    background: #b9d1f7;
  }
</style>
<style media="print">
  @page {
    size: auto;
    margin: 3mm;
  }

  /* html {
  background-color: #ffffff;
  height: auto;
  margin: 0px;
} */
</style>